<form [formGroup]="contentForm" class="content-managers-form">
  <!-- Dirección correo -->
  <section class="email">
    <ion-row class="form__row">
      <ion-col sizeMd="12" sizeLg="6" class="form__col-label">
        <ion-label class="email__label">
          Defina buzón de correo por defecto al que serán enviadas las notificaciones para la autorización del contenido</ion-label>
      </ion-col>
      <ion-col sizeMd="12" sizeLg="6" class="form__col-email">
        <app-input
        [formGroup]="contentForm"
        formControlName="email"
        [required]="false"
        />
      </ion-col>
    </ion-row>
  </section>
  <!-- Buscador responsables -->
  <section class="content-managers-form__managers">
    <section class="search">
      <ion-row class="form__row">
        <ion-col size="12" sizeMd="12" class="form__input">
          <h2 position="stacked" class="content-managers-form__section-title">
            Seleccione a los Responsables que validarán el acceso al contenido
          </h2>
          <ion-label class="search__label">Nombre</ion-label>
          <ion-searchbar class="search__searchbar" show-clear-button="always" formControlName="search"
            placeholder="Nombre"></ion-searchbar>@if (showList) {
          <div class="dropdown-container">
            <ion-list class="dropdown-list">
              @if (resultados && resultados.length > 0) { @for (resultado of
              resultados; track $index) {
              <ion-item (click)="addManager(resultado)">
                {{ resultado.name }}
              </ion-item>
              }} @else {
              <ion-item> No existen resultados </ion-item>
              }
            </ion-list>
          </div>
          }
        </ion-col>
      </ion-row>
    </section>
    <!-- Card / mensaje responsable -->
    <section class="managers">
      <h2 position="stacked" class="content-managers-form__section-title">LISTADO DE RESPONSABLES DE CONTENIDO SELECCIONADOS</h2>
      <section class="managers__cards">
        @for (item of managersContent; track $index) {
        <app-manager-card [manager]="item" (deleteManager)="deleteManager($event)" />
        }
        @if (!managersContent || managersContent.length
        < 1) { <app-general-error type="warning" code="content.warning-manager" />
        }
      </section>
    </section>
  </section>
</form>
